import { useNavigate } from "react-router-dom";
import '../../Pages/Pricing/Pricing.css'
import { usePageSeo } from "../../Hooks/usePageSeo";

const Page = (props: any) => {

    usePageSeo(props);

    const cssClass = "Page " + props.className;

    return <div className={cssClass}>
        {props.children}
    </div>
};

export default Page;